export const createSetWidgetHeightHandler = setHeight => (...args) => {
  setHeight(...args);
};
